<template>
  <div class="min-height">
    <TableLoading v-if="roles.page === 0"/>
    <div v-else>
      <form @submit.prevent="staffAction">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>First Name</label>
            <input
                v-model="staff.firstName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.firstName.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.firstName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Last Name</label>
            <input
                v-model="staff.lastName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.lastName.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.lastName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Roles</label>
            <multiselect v-model="staff.roles" :options="roles.objects" :class="{
                            'is-invalid': v$.staff.roles.$error,
                      }" :multiple="true" :close-on-select="false" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
            <p
                v-for="error in v$.staff.roles.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Email</label>
            <input
                v-model="staff.email"
                name="name"
                type="email"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.email.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.email.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Phone Number</label>
            <input
                v-model="staff.phoneNumber"
                type="tel"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.phoneNumber.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.phoneNumber.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>KRA PIN</label>
            <input
                v-model="staff.profile.kraPin"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.profile.kraPin.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.profile.kraPin.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>ID Number</label>
            <input
                v-model="staff.profile.idNumber"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.profile.idNumber.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.profile.idNumber.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>NHIF</label>
            <input
                v-model="staff.profile.nhif"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.profile.nhif.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.profile.nhif.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>NSSF</label>
            <input
                v-model="staff.profile.nssf"
                name="name"
                type="number"
                class="form-control py-3"
                :class="{'is-invalid': v$.staff.profile.nssf.$error}"
            />
            <p
                v-for="error of v$.staff.profile.nssf.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Physical Address</label>
            <input
                v-model="staff.profile.physicalAddress"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.profile.physicalAddress.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.profile.physicalAddress.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>PO Box - Postal Code</label>
            <input
                v-model="staff.profile.poBox"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.staff.profile.poBox.$error,
                      }"
            />
            <p
                v-for="error of v$.staff.profile.poBox.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="mb-3 col-sm-4">
            <label>Date of Birth</label>
            <date-picker v-model="staff.profile.dob" class="date-picker-height-3" format="YYYY-MM-DD" valueType="format" :class="{
                            'is-invalid': v$.staff.profile.dob.$error,
                      }"></date-picker>
            <p
                v-for="error of v$.staff.profile.dob.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div v-for="(error, index) in userAdministrationErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <div class="mt-3 align-middle">
            <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="userAdministrationLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="primary" size="lg" class="py-3 h3 text-white w-100" type="submit" v-else>
              {{ button_text }}
            </b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {ALL_ROLES} from "@/gql";
import {mapGetters} from "vuex";
import TableLoading from "@/components/TableLoading";

export default {
name: "staff-form",
  components: {TableLoading, Multiselect},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      staff: this.selected_staff,
      roles:{
        pages: 0,
        objects: []
      },
    }
  },
  apollo: {
    roles: {
      query: ALL_ROLES,
      variables () {
        return {
          page: 0,
          perPage: 30
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      userAdministrationLoading: 'administration/userAdministrationLoading',
      userAdministrationErrors: 'administration/userAdministrationErrors'
    }),
  },
  validations () {
    return {
      staff: {
        firstName: {required},
        lastName: {required},
        roles: {required},
        email: {required},
        phoneNumber: {required},
        profile: {
          kraPin: {required},
          idNumber: {required},
          nhif: {required},
          nssf: {required},
          physicalAddress: {required},
          poBox: {required},
          dob: {required}
        }
      }
    }
  },
  props: {
    selected_staff: {
      type: Object,
      default () {
        return {
          roles:"",
          firstName:"",
          lastName: "",
          email:"",
          phoneNumber:"+254",
          profile: {
            kraPin:"",
            idNumber:"",
            nhif:"",
            nssf:"",
            physicalAddress:"",
            poBox:"",
            dob: ""
          }
        }
      }
    },
    button_text: {type: String}
  },
  methods:{
    async staffAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const new_role = []
      this.staff.roles.forEach(object => {
        new_role.push({id: object.id})
      })
      const data = {
        user: {
          firstName: this.staff.firstName,
          lastName: this.staff.lastName,
          email: this.staff.email,
          phoneNumber: this.staff.phoneNumber,
          profile: {
            idNumber: this.staff.profile.idNumber,
            kraPin: this.staff.profile.kraPin,
            nhif: this.staff.profile.nhif,
            nssf: this.staff.profile.nssf,
            physicalAddress: this.staff.profile.physicalAddress,
            poBox: this.staff.profile.poBox,
            dob: this.staff.profile.dob
          }
        },
        roles: new_role
      }
      delete data.user.roles
      this.$emit('staffAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
